import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Writing from "./pages/Writing";
import Game from "./pages/Game";
import Typing from "./pages/Typing";
import StrokeOrder from "./pages/StrokeOrder";
import Vocabulary from "./pages/Vocabulary";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import About from "./pages/About";
import Contact from "./pages/Contact";
import BookALesson from "./pages/BookALesson";
import Header from "./components/Header";
import Footer from "./components/Footer";
import translations from "./translations";
import { hiraganaMaterials } from "./data/materials";
import { socialLinks } from "./data/socialLinks";
import { characterImages } from "./data/characters";
import logo from "./assets/logo.png";
import logo_text from "./assets/logo_text.png";
import weixinImg from "./assets/images/weixin.JPG";

function ScrollToTopOnNav() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  const { pathname } = useLocation();
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem("language") || "EN";
  });
  const [weixinOpen, setWeixinOpen] = useState(false);
  const [typingPhase, setTypingPhase] = useState("start");

  const texts = translations[language];

  const [menuOpen, setMenuOpen] = useState(false);

  const [selectedVideo, setSelectedVideo] = useState(null);

  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  const toggleLanguage = () => {
    if (language === "JP") setLanguage("EN");
    else if (language === "EN") setLanguage("ZH");
    else setLanguage("JP");
  };

  const fontClass =
    language === "JP" ? "font-jp" :
      language === "ZH" ? "font-zh" :
        "font-en";

  const handlePrint = (image, title) => {
    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    printWindow.document.write(`
      <html>
        <head>
          <title>${title}</title>
          <style>
            @media print {
              body, html {
                margin: 0;
                padding: 0;
              }
              img {
                width: 210mm;
                height: 297mm;
                object-fit: contain;
              }
            }
          </style>
        </head>
        <body>
          <img src="${image}" alt="${title}" />
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const handleDownload = (file) => {
    const link = document.createElement("a");
    link.href = file;
    link.download = file.split("/").pop();
    link.click();
  };

  return (
    <div className={`relative ${fontClass}`}>
      {/* WeChat QR popup */}
      {weixinOpen && (
        <div
          className="fixed inset-0 bg-black/70 flex items-center justify-center z-[200] p-4"
          onClick={() => setWeixinOpen(false)}
        >
          <div
            className="bg-white rounded-2xl p-4 shadow-2xl max-w-xs w-full flex flex-col items-center gap-3"
            onClick={(e) => e.stopPropagation()}
          >
            <img src={weixinImg} alt="WeChat QR" className="w-full rounded-xl object-contain" />
            <button
              onClick={() => setWeixinOpen(false)}
              className="text-sm text-gray-400 hover:text-gray-600 transition"
            >✕ Close</button>
          </div>
        </div>
      )}

      <Header
        logo={logo}
        logo_text={logo_text}
        language={language}
        setLanguage={setLanguage}
        toggleLanguage={toggleLanguage}
        texts={texts}
        onWeixinClick={() => setWeixinOpen(true)}
      />

      <ScrollToTopOnNav />
      <Routes>
        <Route
          path="/"
          element={<Home language={language} texts={texts} />}
        />
        <Route path="/writing" element={<Writing language={language} texts={texts} handlePrint={handlePrint} handleDownload={handleDownload} />} />
        <Route path="/strokeorder" element={<StrokeOrder language={language} />} />
        <Route path="/game" element={<Game lang={language.toLowerCase()} />} />
        <Route path="/typing" element={<Typing lang={language.toLowerCase()} onPhaseChange={setTypingPhase} />} />
        <Route path="/vocabulary" element={<Vocabulary language={language} />} />
        <Route path="/about" element={<About language={language} texts={texts} />} />
        <Route path="/contact" element={<Contact language={language} />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy language={language} />} />
        {/* <Route path="/bookalesson" element={<BookALesson language={language} />} /> */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {!(pathname === "/typing" && typingPhase === "quiz") && (
        <Footer
          language={language}
          onWeixinClick={() => setWeixinOpen(true)}
        />
      )}
    </div>
  );
}